// import { http } from "services/http"

const getS3Url = async (documentName) => {
    // const res = await http.get(`obikestore/mediaputurl?name=${documentName}`,  {}).catch(e => catchError(e))
    const res = false
    // console.log("getS3Url res: ", res)
    return res
}

const fetchCityList = async (cp) => {
    return fetch(`https://geo.api.gouv.fr/communes?codePostal=${cp}&fields=nom,codeInsee,codesPostaux,codeDepartement,codeRegion&format=json&geometry=centre`)
        .then((response) => response.json())
        .catch(e => null)
}

const getCoordinates = async (adresse, postCode, city) => {
    return fetch(`https://api-adresse.data.gouv.fr/search/?q=${adresse}&limit=1&postcode=${postCode}&city=${city}`)
        .then(response => response.json())
        .then(data => ({
            ...(data.features[0]?.geometry?.coordinates[0] ? { longitude: data.features[0]?.geometry?.coordinates[0] } : {}),
            ...(data.features[0]?.geometry?.coordinates[1] ? { latitude: data.features[0]?.geometry?.coordinates[1] } : {}),
            ...(data.features[0]?.properties?.citycode ? { citycode: data.features[0]?.properties?.citycode } : {}),
        }))
        .catch(e => null)
}

export { getS3Url, fetchCityList, getCoordinates }